export default __webpack_public_path__ + "static/media/side-effects-by-method-sprite@2x.ca018ecb.png";